define.alias("shared/errors/fetch", "media/errors/fetch");